import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {RenderOffestViolationCell, RenderVTable} from "../../../ActTable/ActTable";
import {useFormik} from "formik";
import {useSelector} from "react-redux";

import {DataGrid, GridToolbarContainer, ruRU} from "@material-ui/data-grid";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from '@material-ui/icons/Add';
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DeleteIcon from '@material-ui/icons/Delete';
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import makeStyles from "@material-ui/core/styles/makeStyles";
import FormHelperText from "@material-ui/core/FormHelperText";

import CreateIcon from '@material-ui/icons/Create';
import DoneIcon from '@material-ui/icons/Done';

import {DynamicFieldComponent} from "../../DynamicFieldComponent";
import {HeaderWithCloseButton} from "../../../tools/HeaderWithCloseButton/HeaderWithCloseButton";

import {
    generateFormikInitialValues,
    generateFormikValidationSchema,
    parseFieldVariables
} from "../../../../utils/dynamicFields";

import {getActiveEnvironmentState} from "../../../../redux/reducers/master-of-acts-reducer";

import {getProfile} from "../../../../redux/reducers/user-profile-reducer";

import {MasterOfActsAPI} from "../../../../api/api";


const useStyles = makeStyles(theme => ({
    tableError: {
        borderColor: theme.palette.error.main,
        '& .MuiDataGrid-cell': {
            lineHeight: 'normal !important',
        },
    },
    inline: {
        '& .MuiDataGrid-cell:not(:nth-child(2))': {
            lineHeight: 'normal !important',
          },
    },
}))

const CustomToolbar = ({
                           onAddButtonClick,
                           onDeleteButtonClick,
                           disabledDeleteButton,
                           disabled
                       }) => {
    return <GridToolbarContainer>
        <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'}>
            <Grid item>
                {
                    !disabled ? <IconButton disabled={disabledDeleteButton} onClick={onDeleteButtonClick}>
                        <DeleteIcon style={{color: disabledDeleteButton ? "grey" : "red"}}/>
                    </IconButton> : null
                }
            </Grid>
            <Grid item>
                {
                    !disabled ? <IconButton onClick={onAddButtonClick}>
                        <AddIcon style={{color: "green"}}/>
                    </IconButton> : null
                }
            </Grid>
        </Grid>
    </GridToolbarContainer>
}

const SelectedOffenseListModes = {
    VIEW: 'VIEW',
    EDIT: 'EDIT',
    CREATE: 'CREATE'
}

const getViolationTableColumnsAnother = (tableConfig, normativeArticleVariable, editRow, setEditRow, fields, formik, editOffenseinline, changeOffense) => {

    const columns = [{
        field: 'rowSequenceNumber',
        headerName: '№',
        width: 75
    }]
    if (normativeArticleVariable) {
        columns.push({
            field: normativeArticleVariable,
            headerName: 'Пункты',
            valueFormatter: ({value}) => {
                return value[0]?.shortText
            },
            flex: 2,
            renderCell: RenderOffestViolationCell,
        })
    }
    if (tableConfig?.columns && tableConfig?.columns?.length !== 0) {
        columns.push(...tableConfig.columns.map(({field, flex, headerName, type: typeField}) => {
            return {
                field: field,
                headerName: headerName,
                flex: flex,
                renderCell: (params) => {
                   const isEdit = editRow?.filter(({id}) => params.id === id)[0]?.edit;
                   return RenderVTable(params, typeField, isEdit, fields, formik)
                }
            }
        }))
    }
    columns.push({
        field: 'edit',
        headerName: 'Редактировать',
        width: 100,
        renderCell: (params) => {
            const isEdit = editRow?.filter(({id}) => params.id === id)[0]?.edit;
            const disabledAnother = editRow?.some(({edit}) => edit);
            return isEdit 
                ? 
                    <IconButton>
                        <DoneIcon
                            onClick={() => {
                                changeOffense();
                                setEditRow((prev) => {
                                    return prev.map(({id, edit}) => {
                                        return {
                                            id,
                                            edit: params.id === id ? !edit : edit
                                        }
                                    })
                                })
                            }} 
                        /> 
                    </IconButton>
                : 
                    <IconButton
                        disabled={disabledAnother}
                    >
                        <CreateIcon 
                            onClick={() => {
                                    setEditRow((prev) => {
                                        return prev.map(({id, edit}) => {
                                            return {
                                                id,
                                                edit: params.id === id ? !edit : edit
                                            }
                                        })
                                    })
                                    if (params.id) {
                                        editOffenseinline(params.id)
                                    }
                                }
                            } 
                        /> 
                    </IconButton>
        },
    })

    return columns
}


export const SelectedOffenseList = (props) => {
    const {content, variable, value, error, touched, setFieldValue, disabled, selectedAct} = props;
    
    const [qrHash, setQrHash] = useState('')
    const classes = useStyles();

    const [editRow, setEditRow] = useState(value.map(({id}) => {
        return {
            id,
            edit: false,
        }
    }));

    const formikInitialValues = useMemo(() => generateFormikInitialValues(content.offenseWindow), [content.offenseWindow])
    
    const formikValidationSchema = useMemo(() => generateFormikValidationSchema(content.offenseWindow), [content.offenseWindow])
    
    
    const fields = useMemo(() => content?.offenseWindow.sort((a, b) => a.sequenceNumber - b.sequenceNumber
    ), [content])
    
    const environmentState = useSelector(getActiveEnvironmentState)
    
    const {user} = useSelector(getProfile)
    const [selectionModel, setSelectionModel] = useState([])
    
    const [mode, setMode] = useState(disabled ?
        SelectedOffenseListModes.VIEW :
        SelectedOffenseListModes.CREATE)

    const formik = useFormik({
        initialValues: formikInitialValues,
        validationSchema: formikValidationSchema
    })

    const [isOpenOffense, setIsOpenOffense] = useState(false)
   
    const deleteRows = async () => {
        setFieldValue(variable, value.filter(f => !selectionModel.includes(f.id)))
        setEditRow((prev) => prev.filter(f => !selectionModel.includes(f.id)))
        setSelectionModel([])
    }

    const closeOffense = useCallback(() => {
        setIsOpenOffense(false)
        formik.resetForm()
    }, [formik])


    const openOffense = () => {
        setIsOpenOffense(true)
    }

    const onCreateOffense = () => {
        setMode(SelectedOffenseListModes.CREATE)
        openOffense()
    }

    const addOffense = async () => {
        const errors = await formik.validateForm()
        if (Object.keys(errors).length === 0) {
            const copyOffense = {...formik.values}
            const normativeArticleValue = copyOffense[content.normativeArticleVariable]
            const filesValue = copyOffense[content.filesVariable]
            delete copyOffense[content.filesVariable]
            
            let violationVariables = parseFieldVariables(copyOffense, content.offenseWindow)

            const response = await MasterOfActsAPI.addViolation(
                normativeArticleValue && normativeArticleValue?.length !== 0 ? normativeArticleValue[0].shortText:
                'Нормативный пункт не указан',
                copyOffense,
                formik.values,
                environmentState.id,
                selectedAct?.creator ? selectedAct?.creator : user.id,
                normativeArticleValue?.map(el => el.id),
                filesValue?.map(el => el.id)
            )
            if (response.status === 201) {
               

                setFieldValue(variable, [...value, {...violationVariables, id: response.data.id, qrCodeViolation: response.data.qrcode_web}])
                setEditRow((prev) => [...prev, {id: response.data.id, edit: false}])
                formik.resetForm(formikInitialValues)
                closeOffense()
            }
        } else {
            let touched = {}
            for (const field of Object.keys(errors)) {
                touched[field] = true
            }
            await formik.setTouched(touched, false)
            await formik.setErrors(errors)
        }
    }
    const editOffense = async (params) => {

        setQrHash(params.row.qrCodeViolation)
        const response = await MasterOfActsAPI.getViolation(params.id)

        if (response.status === 200) {
            await formik.setValues({...response.data.raw_content, id: response.data.id})
            setMode(disabled ? SelectedOffenseListModes.VIEW :
                SelectedOffenseListModes.EDIT)
            openOffense()
        }
    }

    const editOffenseinline = useCallback( async (id) => {
        const response = await MasterOfActsAPI.getViolation(id)
        if (response.status === 200) {
            await formik.setValues({...response.data.raw_content, id: response.data.id})
            setMode(disabled ? SelectedOffenseListModes.VIEW :
                SelectedOffenseListModes.EDIT)
        }
    }, [formik, disabled])

    const changeOffense = useCallback( async () => {
        const errors = await formik.validateForm()
        if (Object.keys(errors).length === 0) {
            const copyOffense = {...formik.values}
            const normativeArticleValue = copyOffense[content.normativeArticleVariable]
            const filesValue = copyOffense[content.filesVariable]
            delete copyOffense[content.filesVariable]
            delete copyOffense['id']

            let violationVariables = parseFieldVariables(copyOffense, content.offenseWindow)

            const response = await MasterOfActsAPI.patchViolation(formik.values.id, {
                    name: normativeArticleValue[0].shortText,
                    content: copyOffense,
                    raw_content: {...formik.values, id: undefined},
                    environment_state: environmentState.id,
                    normative_articles: normativeArticleValue.map(el => el.id),
                    files: (filesValue) ? filesValue.map(el => el.id) : new Array()
                }
            )
            if (response.status === 200) {
                setFieldValue(variable, value.map(el => {
                    if (el.id === response.data.id) {
                        return {...violationVariables, id: response.data.id}
                    }
                    return el
                }))
                formik.resetForm(formikInitialValues)
                closeOffense()
            }
        } else {
            let touched = {}
            for (const field of Object.keys(errors)) {
                touched[field] = true
            }
            await formik.setTouched(touched, false)
            await formik.setErrors(errors)
        }
    }, [
        closeOffense, 
        content.filesVariable, 
        content.normativeArticleVariable, 
        content.offenseWindow, 
        environmentState.id, 
        formik, 
        formikInitialValues, 
        setFieldValue, 
        value, 
        variable
    ])
    const getDynamicFieldKey = (id) => `${id}-dynamic-field`

    const anotherColumns = useMemo(() => {
        return getViolationTableColumnsAnother(
            content?.tableConfig,
            content.normativeArticleVariable, 
            editRow, 
            setEditRow,
            fields,
            formik,
            editOffenseinline,
            changeOffense
        )
    }, [fields, formik, setEditRow, editRow, content.normativeArticleVariable, content?.tableConfig, editOffenseinline, changeOffense])

    return <div>
        <div style={{height: 600, width: '100%'}}>
            <DataGrid rows={value.map((row, index) => ({
                    ...row,
                    'rowSequenceNumber': index + 1,
                }))}
                   
                rowHeight={100} 
                columns={anotherColumns}
                components={{Toolbar: CustomToolbar}}
                componentsProps={{
                    toolbar: {
                        onAddButtonClick: onCreateOffense,
                        onDeleteButtonClick: deleteRows,
                        disabledDeleteButton: selectionModel.length === 0,
                        disabled: disabled
                    }
                }}
                classes={{root: touched && Boolean(error) ? classes.tableError : classes.inline}}
                localeText={ruRU?.props?.MuiDataGrid?.localeText || ruRU?.components?.MuiDataGrid?.defaultProps?.localeText}
                disableSelectionOnClick
                disableColumnMenu
                setEditRow
                checkboxSelection={!disabled && value.length !== 0}
                onSelectionModelChange={(newSelectionModel) => {
                    setSelectionModel(newSelectionModel);
                }}
                selectionModel={selectionModel}
                onRowDoubleClick={(params) => {
                    const editRowFilter = editRow.filter(({ edit }) => edit);
                    const editId = editRowFilter.length > 0 ? editRowFilter[0].id : -1;

                    if (-1 === editId) {

                        editOffense(params)
                    }
                }}
            />
        </div>
        <FormHelperText error={touched && Boolean(error)}>{touched && Boolean(error) ? error : null}</FormHelperText>
        <Dialog open={isOpenOffense} onClose={closeOffense} fullWidth maxWidth={'md'}
                scroll={'paper'}>
            <HeaderWithCloseButton onClose={closeOffense}>
                <Grid item>
                    <Typography variant={'h5'}>
                        Добавление нарушения
                    </Typography>
                </Grid>
            </HeaderWithCloseButton>
            <DialogContent>
                <Grid container spacing={1} direction={"column"}>
                    {fields?.map(field => <Grid item key={getDynamicFieldKey(field.id)}>
                        <DynamicFieldComponent  
                            {...field}
                            {...formik.getFieldProps(field.variable)}
                            touched={formik.touched[field.variable]}
                            error={formik.errors[field.variable]}
                            setFieldValue={formik.setFieldValue}
                            disabled={mode === SelectedOffenseListModes.VIEW}
                            qrHash={qrHash}
                        />
                    </Grid>)}
                </Grid>
            </DialogContent>
            {mode !== SelectedOffenseListModes.VIEW ?
                <DialogActions>
                    <Button onClick={mode === SelectedOffenseListModes.CREATE ?
                        addOffense : changeOffense} color="primary">
                        {mode === SelectedOffenseListModes.CREATE ? 'Добавить нарушение' : 'Сохранить'}
                    </Button>
                </DialogActions> : undefined
            }
        </Dialog>
    </div>
}
